import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import {
  replayIntegrationOptions,
  sentryInitOptions,
  shouldRecordReplayForEvent,
} from "./utils/sentryConfig";

const isProduction = process.env.REACT_APP_NODE_ENV === "production";

if (isProduction) {
  Sentry.init({
    dsn: "https://72646154e85574e72b2e6e7c3405c1d3@o4510668927860736.ingest.us.sentry.io/4511076900143104",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        ...replayIntegrationOptions,
        // Handled (non-crash) errors are tagged handled:true and must NOT pull a
        // replay — see shouldRecordReplayForEvent. Protects the replay quota.
        beforeErrorSampling: shouldRecordReplayForEvent,
      }),
    ],
    ...sentryInitOptions,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
